<template>
  <div class="online-content">
    <div class="online-myCenter">
      <sideBar></sideBar>
      <template v-if="!$route.meta.keepAlive">
        <router-view ></router-view>
      </template>
      <template v-else>
        <router-view ></router-view>
      </template>
    </div>
  </div>
</template>

<script>
import sideBar from "../../components/MyCenter/sideBar"
export default {
  name: "myCenter",
  components: {
    sideBar
  },
  data() {
    return {};
  },
  mounted() {},
  updated() {},
  created() {
    // console.log(this.$store.state.CLASS_NAME)
    // if(this.$store.state.CLASS_NAME == '1' ){//少儿
    //   console.log(111)
    // }else if(this.$store.state.CLASS_NAME == '0'){//幼儿
    //   console.log(2222)
    // }
  },
  watch: {},
  computed: {},
  methods: {
    //删除孩子 - 点击
    handleDelete() {
      this.quitItem = !this.quitItem;
    },

    //密码 和 验证码 切换
    changePsw(val) {
      if (val == 0) {
        //密码
        this.verify.flag = true;
      } else if (val == 1) {
        //验证码
        this.verify.flag = false;
      }
      console.log(val);
    },
    //选择孩子 - 关闭 弹窗
    closeChangeChild() {
      this.verify.dialogVisable = !this.verify.dialogVisable;
    },
    //切换孩子
    clickChild(item, index) {
      console.log(item, index);
      this.childList.forEach((element, index1) => {
        console.log(element, index1);
        this.childList[index1].default = false;
        this.childList[index].default = true;
      });
      this.verify.dialogVisable = !this.verify.dialogVisable;
    }
  }
};
</script>

<style lang="less">
@import url("./myCenter");
</style>
